import { render, staticRenderFns } from "./GroupTodoForm.vue?vue&type=template&id=09739884&"
import script from "./GroupTodoForm.vue?vue&type=script&lang=js&"
export * from "./GroupTodoForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupTodoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports